import * as React from "react";
import {Link} from "react-router-dom";
import {Renewal, PREMIUM_TYPE_MONTHLY, PREMIUM_TYPE_ANNUAL} from "@falcon/services";
import {getAmountToDisplay} from "../../CommonFunctions";

interface IAutoRenewalInviteBannerProps {
    renewalProposal: Renewal;
    showHideWillBeRenewedConfirmation: (display: boolean) => void;
    setAutomaticRenewal: (a: boolean) => void;
    setPerformRenewal: (a: boolean) => void;
    productWording: React.ReactNode;
    monthlyInstalmentsAllowed: boolean;
    renewalEditUrl: string;
}

interface IAutoRenewalInviteBannerState {
    displayInfoMessage: boolean;
}

export class AutoRenewalInviteBanner extends React.Component<IAutoRenewalInviteBannerProps, IAutoRenewalInviteBannerState> {

    constructor(props: IAutoRenewalInviteBannerProps) {
        super(props);

        this.state = {
            displayInfoMessage: false
        };
    }

    public render() {
        const premiumType: string = this.props.renewalProposal.factors.premiumType;
        return (
            <>
                {<div className="banner banner-info">
                    <div className="banner-text">
                        <p><strong>You have opted out of auto-renewal.</strong></p>
                        <p>
                            {this.props.productWording}
                        </p>
                        <p>
                            Set up your renewal for{" "}
                                {premiumType === PREMIUM_TYPE_ANNUAL &&
                                    <>
                                        {getAmountToDisplay(this.props.renewalProposal.factors.annualPremium)} / year.
                                    </>
                                }
                                {premiumType === PREMIUM_TYPE_MONTHLY &&
                                    <>
                                        {getAmountToDisplay(this.props.renewalProposal.paymentDetails.instalmentPlan.monthlyPayment)} / month ({getAmountToDisplay(this.props.renewalProposal.paymentDetails.instalmentPlan.totalAmount)} total).
                                    </>
                                }
                        </p>
                        {premiumType === PREMIUM_TYPE_ANNUAL && this.props.monthlyInstalmentsAllowed &&
                            <p>Monthly instalments are available at additional cost.</p>
                        }
                        <div className="row mt-2">
                            <div className="col-12">
                                <div className="mt-2">
                                    <button type="button"
                                            className="btn btn-primary m-auto"
                                            onClick={this.enableAutoRenewal}>Set up your renewal now
                                    </button>
                                    <Link className="btn btn-transparent" to={this.props.renewalEditUrl + this.props.renewalProposal._id}>View / edit renewal</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}

            </>
        )
    }

    private enableAutoRenewal = (): void => {
        this.props.setAutomaticRenewal(false);
        this.props.setPerformRenewal(true);
        this.props.showHideWillBeRenewedConfirmation(true);
    }

}


